__turbopack_context__.v({
  "cell": "SharesForm-module-scss-module__akDawq__cell",
  "combo-field": "SharesForm-module-scss-module__akDawq__combo-field",
  "form": "SharesForm-module-scss-module__akDawq__form",
  "header-text": "SharesForm-module-scss-module__akDawq__header-text",
  "modal": "SharesForm-module-scss-module__akDawq__modal",
  "modal-trigger": "SharesForm-module-scss-module__akDawq__modal-trigger",
  "range": "SharesForm-module-scss-module__akDawq__range",
  "risk": "SharesForm-module-scss-module__akDawq__risk",
  "roi-table": "SharesForm-module-scss-module__akDawq__roi-table",
  "row": "SharesForm-module-scss-module__akDawq__row",
  "row-header-cell": "SharesForm-module-scss-module__akDawq__row-header-cell",
  "shares": "SharesForm-module-scss-module__akDawq__shares",
  "total": "SharesForm-module-scss-module__akDawq__total",
});
